import { app } from '../shared';

export const fetchUserPartyTargeting = async () => {
  return app.service('user-party-targeting').find({});
};
